import PropTypes from 'prop-types';

const OptionBox = ({ isActive, option, onClick }) => (
  <button
    type="button"
    className={`option-box ${isActive && 'active'}`}
    onClick={onClick}
  >
    {option}
  </button>
);

OptionBox.propTypes = {
  isActive: PropTypes.bool.isRequired,
  option: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default OptionBox;
